module.exports = __webpack_public_path__ + "img/empty_icon_aeflp.ea14e6df.svg";